import { componentWrapper } from "../../../../utilities";
import { Table } from "../../../table";
import { Text } from "../../../text";
import { CustomAutoTableThFactory, IProps } from "./auto-table-column-heading.types";

const AutoTableColumnHeading = componentWrapper<CustomAutoTableThFactory, IProps>(
    "TableColumnHeading",
    ({ children, noWrap, lineClamp, ...otherProps }: IProps, ref) => {
        return (
            <Table.Th ref={ref} {...otherProps}>
                <Text
                    variant="semibold"
                    size="sm"
                    noWrap={noWrap}
                    lineClamp={lineClamp}
                    data-testid="auto-table-column-heading"
                >
                    {children}
                </Text>
            </Table.Th>
        );
    }
);

export { AutoTableColumnHeading };
